import React from 'react';
import * as Common from '_common';
import { AppModule } from './app/AppScreen';
import { IndexModule } from './modules/IndexModule';
const MinecraftModule = React.lazy(() => import(/* webpackChunkName: "mc" */ './modules/MinecraftModule'));
const BlogModule = React.lazy(() => import(/* webpackChunkName: "blog" */ './modules/BlogModule'));
const SettingsModule = React.lazy(() => import(/* webpackChunkName: "settings" */ './modules/SettingsModule'));
const DebugModule = React.lazy(() => import(/* webpackChunkName: "debug" */ './modules/DebugModule'));
export const appModules = [
    {
        id: 'Index',
        name: { en: 'Home', cs: 'Domů' },
        role: 'public',
        components: { module: IndexModule },
    },
    {
        id: 'Blog',
        name: 'Blog',
        role: 'Public',
        components: { module: BlogModule },
    },
    {
        id: 'Minecraft',
        name: 'Minecraft',
        role: 'Minecraft',
        components: { module: MinecraftModule },
        preferedLayout: Common.AppModulePreferedLayout.Minimal,
    },
    {
        id: 'Context',
        name: 'Context',
        role: 'Admin',
        components: { module: AppModule },
    },
    {
        id: 'Users',
        name: 'Users',
        role: 'Admin',
        components: { module: AppModule },
    },
    {
        id: 'Settings',
        name: 'Settings',
        role: 'Admin',
        components: { module: SettingsModule },
    },
    {
        id: 'Debug',
        name: 'Debug',
        role: 'User',
        components: { module: DebugModule },
        preferedLayout: Common.AppModulePreferedLayout.Minimal,
    },
];
export function getAppModule(id) {
    return appModules.find(m => m.id === id);
}
